var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLandingSynastryPreview = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  className: "synastry-svg",
  viewBox: "0 0 720 720",
  "aria-hidden": "true",
  focusable: "false",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId || "synastry-R0-svg-title"
}, "\u0421\u0438\u043D\u0430\u0441\u0442\u0440\u0438\u044F: \u0410\u043D\u043D\u0430 \u0438 \u041C\u0430\u043A\u0441\u0438\u043C. \u0422\u043E\u0447\u043A\u0438 \u2014 \u0442\u043E\u0447\u043D\u044B\u0435 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u044F; \u043B\u0438\u043D\u0438\u0438 \u0432\u0435\u0434\u0443\u0442 \u043A \u043F\u043E\u0434\u043F\u0438\u0441\u044F\u043C.") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId || "synastry-R0-svg-title"
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
  id: "synastry-R0-g0",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19 12a7 7 0 1 1-14 0 7 7 0 0 1 14 0 M12 11.5v1",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "synastry-R0-g1",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 3a9 9 0 1 0 0 18 10 10 0 0 1 0-18Z",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "synastry-R0-g2",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7 3a5 5 0 0 0 10 0 M17 10a5 5 0 1 1-10 0 5 5 0 0 1 10 0 M12 15v7 M8 19h8",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "synastry-R0-g3",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 8a6 6 0 1 1-12 0 6 6 0 0 1 12 0 M12 14v8 M8 19h8",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "synastry-R0-g4",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 15a6 6 0 1 1-12 0 6 6 0 0 1 12 0 M13 11l8-8 M15 3h6v6",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "synastry-R0-g5",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5 5c8-5 9 6 0 9h14 M15 3v19",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "synastry-R0-g6",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 2v15 M4 6h9 M8 11c10-6 11 4 7 9q-1 3 3 1",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "synastry-R0-g7",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4 3v11 M20 3v11 M4 9h16 M12 3v13 M15 19a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "synastry-R0-g8",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5 3v5a7 7 0 0 0 14 0V3 M12 2v20 M8 18h8",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "synastry-R0-g9",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0 M5 7a7 7 0 0 0 14 0 M12 14v8 M8 19h8",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "synastry-R0-g10",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7 18C-2 4 26 4 17 18 M8 19a3 3 0 1 1-6 0 3 3 0 0 1 6 0 M22 19a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "synastry-R0-g11",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7 6C-2 20 26 20 17 6 M8 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0 M22 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "synastry-R0-g12",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 18a4 4 0 1 1-8 0 4 4 0 0 1 8 0 M11 14V2 M11 8l8-6 M11 8l8 6",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "synastry-R0-g13",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5 10C1 0 19 0 19 10H12v12 M8 18h8",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "synastry-R0-g14",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 2l6 6-6 6-6-6Z M12 14v8 M8 18h8",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "synastry-R0-g15",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 2v12 M6 5l12 6 M18 5L6 11 M12 14v8 M8 18h8",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "synastry-R0-g16",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 2c-7 9-7 11 0 14 7-3 7-5 0-14Z M4 17l8 5 8-5",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "synastry-R0-g17",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14 2a7 7 0 1 0 0 14 8 8 0 0 1 0-14Z M11 16v6 M7 19h8",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "synastry-R0-g18",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 2v20 M18 12a6 6 0 1 1-12 0 6 6 0 0 1 12 0",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "synastry-R0-g19",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 5l4 15 5-12 5 12 4-15",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "synastry-R0-g20",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0 M6 6l12 12 M18 6L6 18",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "synastry-R0-g21",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2 5l5 14 5-14 M14 10l8 9 M22 10l-8 9",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "synastry-R0-g22",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 21V8C12-2 0 1 4 10 M12 8C12-2 24 1 20 10",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "synastry-R0-g23",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 15a6 6 0 1 1-12 0 6 6 0 0 1 12 0 M5 2c0 9 14 9 14 0",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "synastry-R0-g24",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4 3q8 4 16 0 M4 21q8-4 16 0 M8 5v14 M16 5v14",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "synastry-R0-g25",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 5C11 0 1 7 5 10c4 3 8-4 2-4 M4 19c9 5 19-2 15-5-4-3-8 4-2 4",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "synastry-R0-g26",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9 16a4 4 0 1 1-8 0 4 4 0 0 1 8 0 M8 14C-1-1 20-2 16 10s-7 15 6 9",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "synastry-R0-g27",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 21V6q2-7 5 0v15 M8 6q3-7 5 0v15 M13 6q3-7 5 0v10 M15 12q9-8 7 0c-2 6-5 8-9 9",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "synastry-R0-g28",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 15h5a6 6 0 1 1 8 0h5 M3 21h18",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "synastry-R0-g29",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 21V6q2-7 5 0v15 M8 6q3-7 5 0v15 M13 6q3-7 5 0v10q0 5 5 3 M20 15l3 4-4 3",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "synastry-R0-g30",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 21L21 3 M11 3h10v10 M5 10l9 9",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "synastry-R0-g31",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2 5l5 16 5-16q4-4 4 4v8a4 4 0 1 0 4-4q-5 0-8 8",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "synastry-R0-g32",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2 9l4-4 4 4 4-4 4 4 4-4 M2 19l4-4 4 4 4-4 4 4 4-4",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "synastry-R0-g33",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5 2q9 10 0 20 M19 2q-9 10 0 20 M2 12h20",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  className: "synastry-rings",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 360,
  cy: 360,
  r: 344,
  className: "synastry-zodiac-surface"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 360,
  cy: 360,
  r: 304,
  className: "synastry-wheel-surface"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 360,
  cy: 360,
  r: 307,
  className: "synastry-ring"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 360,
  cy: 360,
  r: 230,
  className: "synastry-ring"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 360,
  cy: 360,
  r: 114,
  className: "synastry-ring"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  x1: 309.00341607481954,
  y1: 60.30791063499521,
  x2: 302.29333924255894,
  y2: 20.874740981705088
}), /*#__PURE__*/React.createElement("use", {
  href: "#synastry-R0-g22",
  x: 211.83131622807312,
  y: 52.54214745168565,
  width: 26,
  height: 26,
  "aria-hidden": "true"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  x1: 165.9896181320662,
  y1: 125.95732925925986,
  x2: 140.46193630733805,
  y2: 95.16224100389934
}), /*#__PURE__*/React.createElement("use", {
  href: "#synastry-R0-g23",
  x: 82.71155978324867,
  y: 159.57636123531088,
  width: 26,
  height: 26,
  "aria-hidden": "true"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  x1: 74.96074533407943,
  y1: 254.31829250292907,
  x2: 37.45558024645828,
  y2: 240.41280467436712
}), /*#__PURE__*/React.createElement("use", {
  href: "#synastry-R0-g24",
  x: 24.407677463383948,
  y: 316.830587668437,
  width: 26,
  height: 26,
  "aria-hidden": "true"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  x1: 60.30791063499521,
  y1: 410.9965839251804,
  x2: 20.874740981705088,
  y2: 417.706660757441
}), /*#__PURE__*/React.createElement("use", {
  href: "#synastry-R0-g25",
  x: 52.542147451685764,
  y: 482.1686837719271,
  width: 26,
  height: 26,
  "aria-hidden": "true"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  x1: 125.9573292592599,
  y1: 554.0103818679338,
  x2: 95.16224100389934,
  y2: 579.538063692662
}), /*#__PURE__*/React.createElement("use", {
  href: "#synastry-R0-g26",
  x: 159.5763612353108,
  y: 611.2884402167513,
  width: 26,
  height: 26,
  "aria-hidden": "true"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  x1: 254.31829250292907,
  y1: 645.0392546659206,
  x2: 240.4128046743671,
  y2: 682.5444197535417
}), /*#__PURE__*/React.createElement("use", {
  href: "#synastry-R0-g27",
  x: 316.83058766843703,
  y: 669.592322536616,
  width: 26,
  height: 26,
  "aria-hidden": "true"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  x1: 410.9965839251805,
  y1: 659.6920893650048,
  x2: 417.7066607574411,
  y2: 699.1252590182949
}), /*#__PURE__*/React.createElement("use", {
  href: "#synastry-R0-g28",
  x: 482.168683771927,
  y: 641.4578525483143,
  width: 26,
  height: 26,
  "aria-hidden": "true"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  x1: 554.0103818679338,
  y1: 594.0426707407402,
  x2: 579.538063692662,
  y2: 624.8377589961007
}), /*#__PURE__*/React.createElement("use", {
  href: "#synastry-R0-g29",
  x: 611.2884402167513,
  y: 534.4236387646891,
  width: 26,
  height: 26,
  "aria-hidden": "true"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  x1: 645.0392546659206,
  y1: 465.681707497071,
  x2: 682.5444197535417,
  y2: 479.58719532563293
}), /*#__PURE__*/React.createElement("use", {
  href: "#synastry-R0-g30",
  x: 669.592322536616,
  y: 377.16941233156297,
  width: 26,
  height: 26,
  "aria-hidden": "true"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  x1: 659.6920893650048,
  y1: 309.00341607481954,
  x2: 699.1252590182949,
  y2: 302.29333924255894
}), /*#__PURE__*/React.createElement("use", {
  href: "#synastry-R0-g31",
  x: 641.4578525483143,
  y: 211.83131622807304,
  width: 26,
  height: 26,
  "aria-hidden": "true"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  x1: 594.0426707407402,
  y1: 165.9896181320662,
  x2: 624.8377589961007,
  y2: 140.46193630733805
}), /*#__PURE__*/React.createElement("use", {
  href: "#synastry-R0-g32",
  x: 534.4236387646891,
  y: 82.71155978324873,
  width: 26,
  height: 26,
  "aria-hidden": "true"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  x1: 465.681707497071,
  y1: 74.96074533407943,
  x2: 479.58719532563293,
  y2: 37.45558024645828
}), /*#__PURE__*/React.createElement("use", {
  href: "#synastry-R0-g33",
  x: 377.169412331563,
  y: 24.407677463383948,
  width: 26,
  height: 26,
  "aria-hidden": "true"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "synastry-cusp",
  x1: 246,
  y1: 360,
  x2: 56,
  y2: 360.00000000000006
}), /*#__PURE__*/React.createElement("text", {
  x: 237.57573429290855,
  y: 379.7053080686264,
  className: "synastry-house"
}, "I")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "synastry-cusp",
  x1: 251.75781801938865,
  y1: 395.77191691922883,
  x2: 71.35418138503638,
  y2: 455.39177845127693
}), /*#__PURE__*/React.createElement("text", {
  x: 249.49485628147596,
  y: 416.2548950025537,
  className: "synastry-house"
}, "II")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "synastry-cusp",
  x1: 267.38868666848293,
  y1: 426.47664735086727,
  x2: 113.03649778262113,
  y2: 537.2710596023127
}), /*#__PURE__*/React.createElement("text", {
  x: 273.73511830632947,
  y: 449.07508173657226,
  className: "synastry-house"
}, "III")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "synastry-cusp",
  x1: 296.52532416615946,
  y1: 454.6940627905935,
  x2: 190.7341977764252,
  y2: 612.5175007749159
}), /*#__PURE__*/React.createElement("text", {
  x: 318.9744375229553,
  y: 477.01667925318213,
  className: "synastry-house"
}, "IV")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "synastry-cusp",
  x1: 350.4479523325352,
  y1: 473.5991126081471,
  x2: 334.5278728867605,
  y2: 662.9309669550589
}), /*#__PURE__*/React.createElement("text", {
  x: 397.7344069685136,
  y: 478.11906929338124,
  className: "synastry-house"
}, "V")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "synastry-cusp",
  x1: 433.6425272794529,
  y1: 447.021710945574,
  x2: 556.3800727452078,
  y2: 592.057895854864
}), /*#__PURE__*/React.createElement("text", {
  x: 472.491549379468,
  y: 412.16944813017204,
  className: "synastry-house"
}, "VI")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "synastry-cusp",
  x1: 474,
  y1: 360,
  x2: 664,
  y2: 360
}), /*#__PURE__*/React.createElement("text", {
  x: 482.4242657070915,
  y: 340.2946919313737,
  className: "synastry-house"
}, "VII")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "synastry-cusp",
  x1: 468.2421819806114,
  y1: 324.2280830807712,
  x2: 648.6458186149637,
  y2: 264.60822154872335
}), /*#__PURE__*/React.createElement("text", {
  x: 470.5051437185241,
  y: 303.7451049974464,
  className: "synastry-house"
}, "VIII")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "synastry-cusp",
  x1: 452.6113133315172,
  y1: 293.5233526491329,
  x2: 606.9635022173792,
  y2: 182.72894039768778
}), /*#__PURE__*/React.createElement("text", {
  x: 446.26488169367053,
  y: 270.92491826342774,
  className: "synastry-house"
}, "IX")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "synastry-cusp",
  x1: 423.4746758338405,
  y1: 265.30593720940647,
  x2: 529.2658022235746,
  y2: 107.48249922508393
}), /*#__PURE__*/React.createElement("text", {
  x: 401.0255624770448,
  y: 242.98332074681792,
  className: "synastry-house"
}, "X")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "synastry-cusp",
  x1: 369.5520476674648,
  y1: 246.40088739185293,
  x2: 385.47212711323954,
  y2: 57.069033044941136
}), /*#__PURE__*/React.createElement("text", {
  x: 322.2655930314865,
  y: 241.88093070661876,
  className: "synastry-house"
}, "XI")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "synastry-cusp",
  x1: 286.3574727205471,
  y1: 272.978289054426,
  x2: 163.61992725479226,
  y2: 127.942104145136
}), /*#__PURE__*/React.createElement("text", {
  x: 247.50845062053202,
  y: 307.8305518698279,
  className: "synastry-house"
}, "XII")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "synastry-angle",
  x1: 246,
  y1: 360,
  x2: 56,
  y2: 360.00000000000006
}), /*#__PURE__*/React.createElement("text", {
  x: 259,
  y: 360,
  className: "synastry-angle-label"
}, "ASC")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "synastry-angle",
  x1: 423.4746758338405,
  y1: 265.30593720940647,
  x2: 529.2658022235746,
  y2: 107.48249922508393
}), /*#__PURE__*/React.createElement("text", {
  x: 416.23633560717445,
  y: 276.1043829662285,
  className: "synastry-angle-label"
}, "MC")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  className: "synastry-aspects"
}, /*#__PURE__*/React.createElement("g", {
  className: "synastry-aspect soft"
}, /*#__PURE__*/React.createElement("line", {
  x1: 449.5835645466077,
  y1: 325.492247782219,
  x2: 443.16390591165055,
  y2: 428.9040256698992,
  className: "synastry-aspect-line",
  strokeDasharray: "3 4"
}), /*#__PURE__*/React.createElement("line", {
  x1: 449.5835645466077,
  y1: 325.492247782219,
  x2: 443.16390591165055,
  y2: 428.9040256698992,
  className: "synastry-aspect-hit"
})), /*#__PURE__*/React.createElement("g", {
  className: "synastry-aspect conjunction"
}, /*#__PURE__*/React.createElement("line", {
  x1: 449.5835645466077,
  y1: 325.492247782219,
  x2: 464.58014549173237,
  y2: 333.0371891500887,
  className: "synastry-aspect-line"
}), /*#__PURE__*/React.createElement("line", {
  x1: 449.5835645466077,
  y1: 325.492247782219,
  x2: 464.58014549173237,
  y2: 333.0371891500887,
  className: "synastry-aspect-hit"
})), /*#__PURE__*/React.createElement("g", {
  className: "synastry-aspect hard"
}, /*#__PURE__*/React.createElement("line", {
  x1: 447.13674182526773,
  y1: 400.2888101596043,
  x2: 309.2257471711022,
  y2: 455.320382131353,
  className: "synastry-aspect-line",
  strokeDasharray: "8 3"
}), /*#__PURE__*/React.createElement("line", {
  x1: 447.13674182526773,
  y1: 400.2888101596043,
  x2: 309.2257471711022,
  y2: 455.320382131353,
  className: "synastry-aspect-hit"
})))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("line", {
  x1: 248.85507992998527,
  y1: 200.99431852090936,
  x2: 228.2302494015289,
  y2: 171.4881095866451,
  className: "synastry-leader person-A"
}))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("line", {
  x1: 199.10355443357233,
  y1: 251.61026891771724,
  x2: 183.72370115925344,
  y2: 212.26149294443303,
  className: "synastry-leader person-A"
}))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("line", {
  x1: 536.0888324385621,
  y1: 441.41697053086665,
  x2: 568.7651106230373,
  y2: 456.5252743407186,
  className: "synastry-leader person-A"
}))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("line", {
  x1: 517.2613898925882,
  y1: 375.2595953108646,
  x2: 579.3038397362092,
  y2: 429.3240641981921,
  className: "synastry-leader person-A"
}))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("line", {
  x1: 541.0334533546031,
  y1: 290.26558405990096,
  x2: 574.627290059581,
  y2: 277.32517697823306,
  className: "synastry-leader person-A"
}))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("line", {
  x1: 431.37745058964975,
  y1: 179.60803912778678,
  x2: 444.62275069906974,
  y2: 146.13324226490204,
  className: "synastry-leader person-A"
}))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("line", {
  x1: 229.30331216265196,
  y1: 605.3617243751494,
  x2: 220.84093669116902,
  y2: 621.248454730375,
  className: "synastry-leader person-B"
}), /*#__PURE__*/React.createElement("line", {
  x1: 229.30331216265196,
  y1: 605.3617243751494,
  x2: 253.7163848904089,
  y2: 636.2603720391983,
  className: "synastry-leader person-B"
}))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("line", {
  x1: 301.5227025924085,
  y1: 631.7800685994175,
  x2: 238.93207986362387,
  y2: 630.1084202942442,
  className: "synastry-leader person-B"
}))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("line", {
  x1: 574.0700541059156,
  y1: 537.3640660762219,
  x2: 587.9307050911905,
  y2: 548.8480703545385,
  className: "synastry-leader person-B"
}))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("line", {
  x1: 629.197041173163,
  y1: 290.59572762708075,
  x2: 646.6270654217849,
  y2: 286.1019258187617,
  className: "synastry-leader person-B"
}))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("line", {
  x1: 318.63482150849984,
  y1: 85.0947035643614,
  x2: 315.95650059897827,
  y2: 67.29508005414021,
  className: "synastry-leader person-B"
}))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
  className: "synastry-anchor person-A",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 574.627290059581,
  cy: 277.32517697823306,
  r: 3
}))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
  className: "synastry-anchor person-A",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 568.7651106230373,
  cy: 456.5252743407186,
  r: 3
}))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
  className: "synastry-anchor person-A",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 579.3038397362092,
  cy: 429.3240641981921,
  r: 3
}))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
  className: "synastry-anchor person-A",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 444.62275069906974,
  cy: 146.13324226490204,
  r: 3
}))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
  className: "synastry-anchor person-A",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 228.2302494015289,
  cy: 171.4881095866451,
  r: 3
}))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
  className: "synastry-anchor person-A",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 183.72370115925344,
  cy: 212.26149294443303,
  r: 3
}))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
  className: "synastry-anchor person-B",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 220.84093669116902,
  cy: 621.248454730375,
  r: 3
}))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
  className: "synastry-anchor person-B",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 587.9307050911905,
  cy: 548.8480703545385,
  r: 3
}))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
  className: "synastry-anchor person-B",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 238.93207986362387,
  cy: 630.1084202942442,
  r: 3
}))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
  className: "synastry-anchor person-B",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 253.7163848904089,
  cy: 636.2603720391983,
  r: 3
}))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
  className: "synastry-anchor person-B",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 646.6270654217849,
  cy: 286.1019258187617,
  r: 3
}))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
  className: "synastry-anchor person-B",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 315.95650059897827,
  cy: 67.29508005414021,
  r: 3
}))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(248.85507992998527 200.99431852090936)",
  className: "synastry-planet person-A"
}, /*#__PURE__*/React.createElement("circle", {
  r: 33,
  className: "synastry-planet-hit"
}), /*#__PURE__*/React.createElement("circle", {
  r: 25,
  className: "synastry-marker"
}), /*#__PURE__*/React.createElement("use", {
  href: "#synastry-R0-g5",
  x: -15,
  y: -15,
  width: 30,
  height: 30,
  "aria-hidden": "true"
}))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(199.10355443357233 251.61026891771724)",
  className: "synastry-planet person-A"
}, /*#__PURE__*/React.createElement("circle", {
  r: 33,
  className: "synastry-planet-hit"
}), /*#__PURE__*/React.createElement("circle", {
  r: 25,
  className: "synastry-marker"
}), /*#__PURE__*/React.createElement("use", {
  href: "#synastry-R0-g6",
  x: -15,
  y: -15,
  width: 30,
  height: 30,
  "aria-hidden": "true"
}))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(536.0888324385621 441.41697053086665)",
  className: "synastry-planet person-A"
}, /*#__PURE__*/React.createElement("circle", {
  r: 33,
  className: "synastry-planet-hit"
}), /*#__PURE__*/React.createElement("circle", {
  r: 25,
  className: "synastry-marker"
}), /*#__PURE__*/React.createElement("use", {
  href: "#synastry-R0-g1",
  x: -15,
  y: -15,
  width: 30,
  height: 30,
  "aria-hidden": "true"
}))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(517.2613898925882 375.2595953108646)",
  className: "synastry-planet person-A"
}, /*#__PURE__*/React.createElement("circle", {
  r: 33,
  className: "synastry-planet-hit"
}), /*#__PURE__*/React.createElement("circle", {
  r: 25,
  className: "synastry-marker"
}), /*#__PURE__*/React.createElement("use", {
  href: "#synastry-R0-g3",
  x: -15,
  y: -15,
  width: 30,
  height: 30,
  "aria-hidden": "true"
}))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(541.0334533546031 290.26558405990096)",
  className: "synastry-planet person-A"
}, /*#__PURE__*/React.createElement("circle", {
  r: 33,
  className: "synastry-planet-hit"
}), /*#__PURE__*/React.createElement("circle", {
  r: 25,
  className: "synastry-marker"
}), /*#__PURE__*/React.createElement("use", {
  href: "#synastry-R0-g0",
  x: -15,
  y: -15,
  width: 30,
  height: 30,
  "aria-hidden": "true"
}))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(431.37745058964975 179.60803912778678)",
  className: "synastry-planet person-A"
}, /*#__PURE__*/React.createElement("circle", {
  r: 33,
  className: "synastry-planet-hit"
}), /*#__PURE__*/React.createElement("circle", {
  r: 25,
  className: "synastry-marker"
}), /*#__PURE__*/React.createElement("use", {
  href: "#synastry-R0-g4",
  x: -15,
  y: -15,
  width: 30,
  height: 30,
  "aria-hidden": "true"
}))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(229.30331216265196 605.3617243751494)",
  className: "synastry-planet person-B"
}, /*#__PURE__*/React.createElement("circle", {
  r: 33,
  className: "synastry-planet-hit"
}), /*#__PURE__*/React.createElement("circle", {
  r: 25,
  className: "synastry-marker"
}), /*#__PURE__*/React.createElement("use", {
  href: "#synastry-R0-g0",
  x: -20,
  y: -15,
  width: 30,
  height: 30,
  "aria-hidden": "true"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(20 -20)",
  className: "synastry-group-badge",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("circle", {
  r: 12
}), /*#__PURE__*/React.createElement("text", {
  y: 1
}, "2")))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(301.5227025924085 631.7800685994175)",
  className: "synastry-planet person-B"
}, /*#__PURE__*/React.createElement("circle", {
  r: 33,
  className: "synastry-planet-hit"
}), /*#__PURE__*/React.createElement("circle", {
  r: 25,
  className: "synastry-marker"
}), /*#__PURE__*/React.createElement("use", {
  href: "#synastry-R0-g3",
  x: -15,
  y: -15,
  width: 30,
  height: 30,
  "aria-hidden": "true"
}))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(574.0700541059156 537.3640660762219)",
  className: "synastry-planet person-B"
}, /*#__PURE__*/React.createElement("circle", {
  r: 33,
  className: "synastry-planet-hit"
}), /*#__PURE__*/React.createElement("circle", {
  r: 25,
  className: "synastry-marker"
}), /*#__PURE__*/React.createElement("use", {
  href: "#synastry-R0-g1",
  x: -15,
  y: -15,
  width: 30,
  height: 30,
  "aria-hidden": "true"
}))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(629.197041173163 290.59572762708075)",
  className: "synastry-planet person-B"
}, /*#__PURE__*/React.createElement("circle", {
  r: 33,
  className: "synastry-planet-hit"
}), /*#__PURE__*/React.createElement("circle", {
  r: 25,
  className: "synastry-marker"
}), /*#__PURE__*/React.createElement("use", {
  href: "#synastry-R0-g5",
  x: -15,
  y: -15,
  width: 30,
  height: 30,
  "aria-hidden": "true"
}))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(318.63482150849984 85.0947035643614)",
  className: "synastry-planet person-B"
}, /*#__PURE__*/React.createElement("circle", {
  r: 33,
  className: "synastry-planet-hit"
}), /*#__PURE__*/React.createElement("circle", {
  r: 25,
  className: "synastry-marker"
}), /*#__PURE__*/React.createElement("use", {
  href: "#synastry-R0-g6",
  x: -15,
  y: -15,
  width: 30,
  height: 30,
  "aria-hidden": "true"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLandingSynastryPreview);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/landing-synastry-preview.d51d8df54bd614462d4a44484585e3ff.svg";